import { render, staticRenderFns } from "./PointsDraggable.vue?vue&type=template&id=7a82f402&scoped=true&"
import script from "./PointsDraggable.vue?vue&type=script&lang=js&"
export * from "./PointsDraggable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a82f402",
  null
  
)

export default component.exports